// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2r2c9","content":"styles_content__1cj27","selectAll":"styles_selectAll__1ddY0"};